import React from 'react';

import { useTheme } from 'styled-components';

import { BsInfoCircleFill } from 'react-icons/bs';

import { Container } from './styles';

const Summary: React.FC = ({ children }) => {
  const { colors } = useTheme();

  return (
    <Container>
      <i>
        <BsInfoCircleFill size={22} color={colors.IC1} />
      </i>
      {children}
    </Container>
  );
};

export default Summary;
